module.exports = __webpack_public_path__ + "4ff430187034741be1a4e3992b31242b.pdf";